import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { fetchKnmSubjectTypes } from 'APIPackage/CatalogsModule/services/knmSubjectTypesApi';
import { IKnmSubjectType } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectType';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';

import { createKnmSubjectTypeSelectOption } from '../common/createKnmSubjectTypeSelectOption';
import { IKnmSubjectTypeSelectOption } from '../interfaces/IKnmSubjectTypeSelectOption';

export function useKnmSubjectTypes() {
  const isMounted = useMountedState();
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [knmSubjectTypes, setKnmSubjectTypes] = useState<IKnmSubjectType[]>([]);
  const [knmSubjectTypesSelectOptions, setKnmSubjectTypesSelectOptions] = useState<IKnmSubjectTypeSelectOption[]>([]);

  const refresh = useCallback(async () => {
    try {
      dispatch(coreSetLoading(true));
      const types = await fetchKnmSubjectTypes();

      if (isMounted()) {
        setKnmSubjectTypes(types);
      }
    } finally {
      dispatch(coreSetLoading(false));
    }
  }, [dispatch, isMounted]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    setKnmSubjectTypesSelectOptions(
      knmSubjectTypes.map(knmSubjectType => createKnmSubjectTypeSelectOption(knmSubjectType)),
    );
  }, [knmSubjectTypes]);

  return {
    refresh,
    knmSubjectTypes,
    knmSubjectTypesSelectOptions,
  };
}
